<template>
  <div>
      <section class="section is-medium">
    <div class="container">
      
      
      <div class="columns is-centered">
        <div class="column is-8">
          <div class="content is-medium">
            <h1>Product Updates</h1>
            <h2 id="v2-0-2-april-28th-2025">v2.0.2 - April 28th 2025</h2>
<ul>
<li>Fixed EFP Preview not updating on certain input fields</li>
</ul>
<h2 id="v2-0-1-april-17th-2025">v2.0.1 - April 17th 2025</h2>
<ul>
<li>Various fixes and improvements</li>
</ul>

            <h2 id="v1-0-104-april-11th-2025">v1.0.104 - April 11th 2025</h2>
<ul>
<li>Fixed ambious typShareTwitterHandle feature to be fully free</li>
<li>Added show result on Thank You Pages for newsletter surveys and one time polls (Admin V2 only)</li>
</ul>

            <h2 id="v1-0-103-april-2nd-2025">v1.0.103 - April 2nd 2025</h2>
<ul>
<li>Fixed limit detection on new surveys</li>
</ul>

<h2 id="v1-0-102-march-21st-2025">v1.0.102 - March 21st 2025</h2>
<ul>
<li>Performance improvements under the hood</li>
<li>Fixed minor bug with hosted survey entry</li>
</ul>

            <h2 id="v1-0-101-march-18th-2025">v1.0.101 - March 18th 2025</h2>
<ul>
<li>Fixed html entity encoded characters in CSV export</li>
<li>Added hint to the CSV export downloads that&#39;s utf encoded</li>
</ul>

            <h2 id="v1-0-100-january-24th-2025">v1.0.100 - January 24th 2025</h2>
<ul>
<li>Fixed a rare bug in password reset</li>
</ul>

            <h2 id="v1-0-99-january-17th-2025">v1.0.99 - January 17th 2025</h2>
<ul>
<li>Show feedback id on a feedback card</li>
</ul>

            <h2 id="v1-0-98-january-10th-2025">v1.0.98 - January 10th 2025</h2>
<ul>
<li>Added possibility to turn off the prefill of the email field on the Extended Feedback Page when an email was given in the request</li>
<li>Added placeholder parameter to the thank you page redirect to get the email address of the reader</li>
</ul>

            <h2 id="v1-0-97-january-8th-2025">v1.0.97 - January 8th 2025</h2>
<ul>
<li>Allow submission of Extended Feedback Page without a comment, but do not save it. Sometimes, users just want to send an empty form.</li>
<li>Added option to make the email field mandatory for Web Rating widgets</li>
</ul>

            <h2 id="v1-0-96-december-7th-2024">v1.0.96 - December 7th 2024</h2>
<ul>
<li>Sorted feedback shown on Wall of Love Grid by date; newest first.</li>
</ul>

            <h2 id="v1-0-95-december-3rd-2024">v1.0.95 - December 3rd 2024</h2>
<ul>
<li>Fixed interruption of welcome sequence when user upgrading</li>
<li>Removed unnecessary voting options in Newsletter Survey defaults</li>
</ul>

            <h2 id="v1-0-94-august-10th-2024">v1.0.94 - August 10th 2024</h2>
<ul>
<li>Fixed thank you redirect when extended feedback page is disabled</li>
</ul>

            <h2 id="v1-0-93-july-23rd-2024">v1.0.93 - July 23rd 2024</h2>
<ul>
<li>Fixed a bug where the confirmation email was sent to the team owner instead of the invited user</li>
</ul>

            <h2 id="v1-0-92-july-15th-2024">v1.0.92 - July 15th 2024</h2>
<ul>
<li>Fixed wrong billing interval on one plan</li>
<li>Prevent creating a new subscription if account is past due</li>
</ul>

            <h2 id="v1-0-91-june-12th-2024">v1.0.91 - June 12th 2024</h2>
<ul>
<li>Added option to show the timestamp of a feedback on a Wall of Love</li>
</ul>

            <h2 id="v1-0-90-june-7th-2024">v1.0.90 - June 7th 2024</h2>
<ul>
<li>Added option to turn off the extended feedback page for newsletter surveys and one-time polls</li>
</ul>

            <h2 id="v1-0-89-june-3rd-2024">v1.0.89 - June 3rd 2024</h2>
<ul>
<li>Made the &quot;vote registered&quot; sentence more noticable on the extended feedback page</li>
</ul>

            <h2 id="v1-0-88-may-17th-2024">v1.0.88 - May 17th 2024</h2>
<ul>
<li>Fixed UI bug when saving one time polls with 1 or 2 options only</li>
<li>Improved survey analytics when one time poll has only 1 or 2 options</li>
<li>Hosted survey page now supports one time polls with 1 or 2 options</li>
</ul>

            <h2 id="v1-0-87-may-14th-2024">v1.0.87 - May 14th 2024</h2>
<ul>
<li>Added pagination to extended feedback section on a survey&#39;s analytics view</li>
</ul>

            <h2 id="v1-0-86-may-10th-2024">v1.0.86 - May 10th 2024</h2>
<ul>
<li>The number of feedback shown under Recent Feedback on the dashboard is now configurable.</li>
</ul>

            <h2 id="v1-0-85-may-7th-2024">v1.0.85 - May 7th 2024</h2>
<ul>
<li>Added the limit for recent feedback on the dashboard again so it does not freeze on large accounts</li>
</ul>

            <h2 id="v1-0-84-april-13th-2024">v1.0.84 - April 13th 2024</h2>
<ul>
<li>Show date and time on feedback cards</li>
</ul>

            <h2 id="v1-0-83-march-15th-2024">v1.0.83 - March 15th 2024</h2>
<ul>
<li>Fixed notification emails not being sent in certain conditions</li>
</ul>

            <h2 id="v1-0-82-march-8th-2024">v1.0.82 - March 8th 2024</h2>
<ul>
<li>Fixed feedback delete</li>
</ul>

            <h2 id="v1-0-81-february-28th-2024">v1.0.81 - February 28th 2024</h2>
<ul>
<li>Added team support/accounts</li>
<li>Added that a single login can own multiple accounts</li>
</ul>

            <h2 id="v1-0-80-february-22nd-2024">v1.0.80 - February 22nd 2024</h2>
<ul>
<li>Added info on payment failures</li>
<li>Improved newsletter dashboard when starting out</li>
<li>Show cancellation effective date in Billing Details</li>
</ul>

            <h2 id="v1-0-79-february-14th-2024">v1.0.79 - February 14th 2024</h2>
<ul>
<li>Added a name field to the Web Rating widgets so you can collect users&#39; names</li>
</ul>

            <h2 id="v1-0-78-february-7th-2024">v1.0.78 - February 7th 2024</h2>
<ul>
<li>Added filtering of comments in the survey&#39;s analytics</li>
<li>Changed handling of NAME placeholder on Extended Feedback Page to be resolved on display</li>
<li>Added carousel view to Wall Of Love embed</li>
<li>Wall of Love embed now includes its own CSS, and no extra configuration step is needed</li>
<li>Added a style option to Wall of Love to select the minimal default style or unstyled to roll your own CSS</li>
<li>Branding on the Wall of Love is turned on by default and can be turned off on paid plans</li>
<li>Updated bot detection ip ranges</li>
</ul>

            <h2 id="v1-0-77-november-1st-2023">v1.0.77 - November 1st 2023</h2>
<ul>
<li>Added table view to &quot;All Surveys&quot;</li>
<li>Added sorting to &quot;All Surveys&quot;</li>
</ul>

            <h2 id="v1-0-76-october-30th-2023">v1.0.76 - October 30th 2023</h2>
<ul>
<li>Allow the same WebRating widget to be shown multile times inline on the same page</li>
<li>The WebRating widget can now be used inline and via timed popup on the same page.</li>
<li>The inline version of WebRating widgets show now the thank you section if the user already voted.</li>
</ul>

            <h2 id="v1-0-75-october-11th-2023">v1.0.75 - October 11th 2023</h2>
<ul>
<li>Added email capturing to WebRating widget</li>
<li>Added page path to WebRating widget and show it on feedback cards</li>
</ul>

            <h2 id="v1-0-74-september-20th-2023">v1.0.74 - September 20th 2023</h2>
<ul>
<li>Prevent Newsletter Survey creation before presets are loaded</li>
<li>Minor adjustments on the downgrade and re-upgrade processes</li>
</ul>

            <h2 id="v1-0-72-september-14th-2023">v1.0.73 - September 14th 2023</h2>
<ul>
<li>Added support for email address preset on Extended Feedback Page</li>
<li>Fixed search for feedback for Wall of Love</li>
<li>Added the survey name to the searched value for feedback selection on Wall of Love</li>
<li>Fixed issue when downgrading to free plan</li>
</ul>

<h2 id="v1-0-72-september-12th-2023">v1.0.72 - September 12th 2023</h2>
<ul>
<li>Added Reply-To email header on notification emails when reader left an email address, otherwise show note that replies do not go to the reader but FeedLetter</li>
<li>Added  5-Star rating to the Web Rating Widget</li>
<li>Updated the preview of Extended Feedback page to latest style</li>
<li>Improved the preview of Extended Feedback page to show live changes for all fields except audio recorder</li>
<li>Linked to FAQ near stats</li>
</ul>

            <h2 id="v1-0-71-june-15th-2023">v1.0.71 - June 15th 2023</h2>
<ul>
<li>Added function to reset stats (voting &amp; feedback) on a survey</li>
</ul>

            <h2 id="v1-0-70-may-26th-2023">v1.0.70 - May 26th 2023</h2>
<ul>
<li>Added an option to show the survey name on a Wall of Love</li>
</ul>

            <h2 id="v1-0-69-may-12th-2023">v1.0.69 - May 12th 2023</h2>
<ul>
<li>Added better error message when email address is already used</li>
</ul>

            <h2 id="v1-0-68-may-10th-2023">v1.0.68 - May 10th 2023</h2>
<ul>
<li>Allow staying logged in from multiple browsers again</li>
<li>Improved handling of auth session expiration</li>
</ul>
            <h2 id="v1-0-67-may-2nd-2023">v1.0.67 - May 2nd 2023</h2>
<ul>
<li>Changed authentication provider</li>
</ul>


            <h2 id="v1-0-66-april-27th-2023">v1.0.66 - April 27th 2023</h2>
<ul>
<li>Updated blocked IP lists for bot detection</li>
<li>Added a table view of the recent newsletter performance to the dashboard</li>
<li>The name of a Wall of Love can be changed now</li>
<li>Labels shown on a Wall of Love can be customized now</li>
<li>&quot;By Anonymous&quot; on a Wall of Love can be removed now on </li>
<li>Freshed up the UI</li>
<li>Improved general error handling </li>
</ul>

            <h2 id="v1-0-65-april-13th-2023">v1.0.65 - April 13th 2023</h2>
<ul>
<li>Allowed more Wall of Loves and feedback on a single Wall of Love on Professional plan</li>
<li>Added CSV export for the newsletter performance chart</li>
</ul>

                        <h2 id="v1-0-64-december-7th-2022">v1.0.64 - December 7th 2022</h2>
<ul>
<li>Added multiple Wall of Loves (Preview release)</li>
<li>Improved UI internally to reduce api calls</li>
</ul>
            <h2 id="v1-0-63-october-13th-2022">v1.0.63 - October 13th 2022</h2>
<ul>
<li>Improved usability of the audio feedback feature on the extended feedback page</li>
<li>Add the audio featute to the new extended feedback page version</li>
</ul>
            <h2>v1.0.62 - September 23th 2022</h2>
            <ul>
              <li>Dashbaord: Show recent feedback even no newsletter chart is available</li>
<li>Added beta of the new feedback collection page with a hosted voting selection (audio recording not available yet) for one-time polls</li>
            </ul>
                        <h2 id="v1-0-61-june-28th-2022">v1.0.61 - June 28th 2022</h2>
<ul>
<li>Block votes from any Google Cloud, AWS or Azure server based on IP-Ranges provided by the cloud providers</li>
</ul>
            <h2 id="v1-0-60-june-2nd-2022">v1.0.60 - June 2nd 2022</h2>
<ul>
<li>Added „Add All Button“ to Wall of Love</li>
<li>Added possibility to edit feedback before adding it to the Wall of Love</li>
<li>Hide feedback that is already on the Wall of Love in the editor </li>
</ul>
<h2 id="v1059---april-2nd-2022">v1.0.59 - April 2nd 2022</h2>

<ul>
<li>Fixed branding removal for subscribers on Wall of love</li>
</ul>

            <h2 id="v1058---april-1st-2022">v1.0.58 - April 1st 2022</h2>

<ul>
<li>Removed the deprecated Wall of Love fallback as announced</li>
<li>Feedback can be deleted now</li>
</ul>

            <h2 id="v1057---march-24th-2022">v1.0.57 - March 24th 2022</h2>

<ul>
<li>Added separate email field to extended feedback page</li>
<li>Added email field to CSV export</li>
<li>Added button on Thank You page to share feedback on Twitter</li>
</ul>

            <h2 id="v1056---march-17th-2022">v1.0.56 - March 17th 2022</h2>

<ul>
<li>Added CSV export for all feedback</li>
<li>Added button to send a test email for notifications</li>
<li>Added button to send a test webhook for notifications</li>
</ul>

            <h2 id="v1055---march-17th-2022">v1.0.55 - March 17th 2022</h2>

<ul>
<li>Improved basic Wall of Love styling</li>
</ul>

            <h2 id="v1054---march-4th-2022">v1.0.54 - March 4th 2022</h2>

<ul>
<li>Select feedback to shown on Wall of Love</li>
<li>General improvements to the Wall of Love feature</li>
<li>Fixed voting labels for exit intent and for newly created WebRating widgets</li>
</ul>

            <h2 id="v1053---march-4th-2022">v1.0.53 - March 4th 2022</h2>

<ul>
<li>Added Webhooks for feedback notifications</li>
<li>Added new business plan</li>
</ul>

            <h2 id="v1052---march-4th-2022">v1.0.52 - March 4th 2022</h2>

<ul>
<li>Fix feedback label on Formview</li>
<li>Preparations for Webhooks</li>
</ul>

<h2 id="v1051---march-2nd-2022">v1.0.51 - March 2nd 2022</h2>

<ul>
<li>Added new bots and bot-like services to bot detection</li>
<li>Added the voted option to notification emails</li>
</ul>

            <h2 id="v1050---november-26th-2021">v1.0.50 - November 26th 2021</h2>

<ul>
<li>Fixed a bug that did shows the <q>limit reached</q> to customers due to an issue in the login state</li>
</ul>

            <h2 id="v10489---october-11th-2021">v1.0.49 - October 11th 2021</h2>

<ul>
<li>Wall of love: Ignore all comments included @ and 3 numbers in a row because it might be an email address or phone number</li>
</ul>

<h2 id="v1048---september-22th-2021">v1.0.48 - September 22th 2021</h2>

<ul>
<li>Fixed loading of default values when form was opened in new tab</li>
<li>Added a feedback button option for the Web Rating Widget</li>
<li>Added in-content support for the Web Rating Widget</li>
</ul>

<h2>v1.0.47 - September 19th 2021</h2>

<ul>
<li>Fixed issue in spam and double vote protection</li>
</ul>
<h2 id="v1046---september-16th-2021">v1.0.46 - September 16th 2021</h2>

<ul>
<li>Allow deactivation of audio feedback on Extended Feedback Page</li>
<li>Added Copy Form feature to Onetime Polls</li>
</ul>

<h2 id="v1045---june-15th-2021">v1.0.45 - June 15th 2021</h2>

<ul>
<li>Fix: Displayed wrong most votes on weekday on dashboard when not all day had a vote</li>
</ul>

            <h2 id="v1044---june-15th-2021">v1.0.45 - June 15th 2021</h2>

<ul>
<li>Fix: hide feedback menu on audio feedback cards</li>
<li>Added new post-upgrade screen</li>
<li>Made time to display configurable for WebRating widgets</li>
</ul>

            <h2 id="v1044---june-15th-2021">v1.0.44 - June 15th 2021</h2>

<ul>
<li>Improved onboarding experience for new users</li>
<li>Fixed character escape in Wall Of Love embeds</li>
</ul>

<h2 id="v1043---june-15th-2021">v1.0.43 - June 15th 2021</h2>

<ul>
<li>Improved feedback to social image for monster-length comments</li>
<li>Use form name for Recent Newsletter Performance and not the date anymore to prevent confusion</li>
<li>Minor style on extended feedback page</li>
<li>Improved load time of extended feedback page</li>
<li>Subheadline on Thank You Page, Thank You Text and on Extended Feedback Page can be empty now</li>
<li>Hide Headline for options on Newsletter Survey + Onetime Poll when option was not set</li>
<li>Allow single option on onetime polls so user can can ask open ended questions</li>
</ul>


            <h2 id="v1042---june-2nd-2021">v1.0.42 - June 2nd 2021</h2>

<ul>
<li>Added copy feedback comments as image card for social media posting</li>
</ul>

            <h2 id="v1041---june-1st-2021">v1.0.41 - June 1st 2021</h2>

<ul>
<li>Fixed bug with name replacement in efp texts on newsletter forms</li>
<li>Design improvements for admin ui</li>
<li>Show branding on feedback page with option to turn it off on Pro plan</li>
<li>Added an Advanced config section on form screens for non-step related configuration</li>
</ul>

            <h2 id="v1040---may-11th-2021">v1.0.40 - May 11th 2021</h2>

<ul>
<li>Enforcing form and comment limits now. Grandfathering in early users.</li>
<li>Voting pages are set to noindex now, so search engines do not index them.</li>
<li>Marketing updates</li>
</ul>

            <h2 id="v1039---may-4th-2021">v1.0.39 - May 4th 2021</h2>

<ul>
<li>Changed voting flow to improve bot detection</li>
<li>Added a copy Web Rating forms on the forms listing</li>
</ul>

<h2 id="v1038---april-16th-2021">v1.0.38 - April 16th 2021</h2>

<ul>
<li>Removed defaults settings for Onetime Polls. Used the newsletter form defaults before, that was misleading</li>
<li>Removed Name field on Onetime Polls. </li>
<li>Smaller UI improvements for Onetime Polls</li>
</ul>

            <h2 id="v1037---april-13rd-2021">v1.0.37 - April 13rd 2021</h2>

<ul>
<li>Updated pricing page with recent changes</li>
<li>Added web rating widgets as form types</li>
<li>Inline support for web rating widgets. Users stay on site and fill out the form inside the widget</li>
</ul>

<h2 id="v1036---march-30th-2021">v1.0.36 - March 30th 2021</h2>

<ul>
<li>Added audio feedback feature. Readers can leave audio feedback now too</li>
</ul>

            <h2 id="v1035---march-23rd-2021">v1.0.35 - March 23rd 2021</h2>

<ul>
<li>New performance chart for newsletter forms on dashboard</li>
<li>Introduced form types for improving analytics and configurability</li>
<li>Added more email providers on home page</li>
</ul>

            <h2 id="v1034---march-16th-2021">v1.0.34 - March 16th 2021</h2>

<ul>
<li>Sanitize feedback input and name to prevent XSS attacks on wall of love</li>
<li>Track web views for widget</li>
<li>Track views for wall of love embed</li>
</ul>

            <h2 id="v1033---march-16th-2021">v1.0.33 - March 16th 2021</h2>

<ul>
<li>Improved layout of wall of love on mobile</li>
<li>Added weekday stats on dashboard</li>
</ul>

<h2 id="v1032---march-12th-2021">v1.0.32 - March 12th 2021</h2>

<ul>
<li>Adjusted the contrast in the admin app for improving readability</li>
<li>Made homepage stats live again</li>
<li>Moved Wall Of Love to new backend</li>
</ul>

            <h2 id="v1031---march-11th-2021">v1.0.31 - March 11th 2021</h2>

<ul>
<li>Adjusted the contrast in the admin app for improving readability.</li>
</ul>

            <h2 id="v1030---march-11th-2021">v1.0.30 - March 11th 2021</h2>

<ul>
<li>refactored backend and data structure to make future improvements possible or easier</li>
</ul>

<h2 id="v1029---march-3nd-2021">v1.0.29 - March 3nd 2021</h2>

<ul>
<li>Prevent double submit on extended feedback form</li>
<li>Prevent double voting by users accidentally reloading the rating page</li>
<li>Added a sidebar menu</li>
<li>Added all time states, this month and previous month totals (only uses 3 star ratings) - grouped by creation date of the feedback form</li>
</ul>

<h2 id="v1028---march-2nd-2021">v1.0.28 - March 2nd 2021</h2>

<ul>
<li>Added first version of the wall of love embed and iframe</li>
<li>Made the review rich snippets added by the web widget a pro feature.</li>
</ul>

<h2 id="v1027---february-26th-2021">v1.0.27 - February 26th 2021</h2>

<ul>
<li>added 5th voting option</li>
<li>JS web widget now adds a json-ld review schema section to the page it&#39;s embedded in. (Shows stars in rich search snippets)</li>
</ul>

            <h2 id="v1026---february-19th-2021">v1.0.26 - February 19th 2021</h2>

<ul>
<li>Now you can finally change your password :-)</li>
</ul>

<h2 id="v1025---february-17th-2021">v1.0.25 - February 17th 2021</h2>

<ul>
<li>Better handling of stale connections to FaunaDB</li>
<li>Fixed JS error in website widget</li>
<li>Added horizontal voting block to insert into emails (Request by early supporter)</li>
</ul>

<h2 id="v1024---february-15th-2021">v1.0.24 - February 15th 2021</h2>

<ul>
<li>fixed discrepancy between daily votes and total votes under certain conditions</li>
</ul>

            <h2 id="v1023---february-11th-2021">v1.0.23 - February 11th 2021</h2>

<ul>
<li>Show preview correctly on Forms - Edit</li>
<li>Added a pricing page with details &amp; reason to upgrade</li>
<li>Small UI changes in the nav menu</li>
</ul>

            <h2 id="v1022---february-5th-2021">v1.0.22 - February 5th 2021</h2>

<ul>
<li>Improved flow for new users</li>
<li>Adjusted UI of form view to make it more clear and easier to navigate depending on what you want to see.</li>
<li>Added simple bot detection to prevent crawlers from voting</li>
</ul>

            <h2 id="v1021---january-29th-2021">v1.0.21 - January 29th 2021</h2>

<ul>
<li>Refactored internal handling of user state and presets settings to make future enhancements easier</li>
<li>Changed prermium detection from token to short-lived query</li>
</ul>

            <h2 id="v1020---january-28th-2021">v1.0.20 - January 28th 2021</h2>

<ul>
<li>Added previews to Customization section for general, extended feedback and thank you page.</li>
</ul>

            <h2>v1.0.19 - January 19th 2021</h2>
            <ul>
<li>Added a FAQ</li>
<li>Created a planned feature page with voting option</li>
</ul>

            <h2>v1.0.18 - January 15th 2021</h2>
            <ul>
              <li>Set cookie on votes with the form id voted on but not the actual vote. Reason, see next item</li>
              <li>Widget is not shown when user already voted on form id</li>
            </ul>
            <h2>v1.0.17 - January 12th 2021</h2>
            <ul>
              <li>Added account setting page with billing infos & form defaults</li>
              <li>Moved form defaults from Form Create to own section under Acounts - Form Defaults. Previous detail handling didn't work well with testing user reader responses in forms</li>
              <li>Added early supporter monthly plan</li>
              <li>Enabled the FeedLetter Widget for collecting feedback on websites</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  </div>
</template>

<script>
export default {
  name: "changeLog",
  data: function () {
    return {

    };
  },
  methods: {
    
  },
};
</script>

